import { Component, OnInit, Input, Output } from '@angular/core';

import { VehicleConfigService } from '../../services/vehicle-config.service';
import { VehicleService } from '../../../vehicles/services/vehicle.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-vehicle-follow-link',
  templateUrl: './vehicle-follow-link.component.html',
  styleUrls: ['./vehicle-follow-link.component.scss']
})
export class VehicleFollowLinkComponent implements OnInit {

  @Input('displayFollowLink') displayFollowLink1: boolean = false;
  @Input('configFollowLink') config: any = [];

  vf: any = {}; //vehicles_follow
  tengoLink:boolean = false;
  strLink:string = '';
  cars:any = [];
  p_vehicles:any = [];
  base_url:string = '';

  constructor(
        private configService: VehicleConfigService,
        private VehicleService: VehicleService,
        private router: Router,
        private location: Location,
  ) { }

  ngOnInit(): void {
    console.log('================================= CREAR LINK ==  ngOnInit');
    // console.log(this.router);
    // console.log(this.router.url);

    // console.log(this.router.config); // ActivatedRouteSnapshot
    // console.log(this.router.url); // UrlSegment[]
    // console.log(this.router.url[0]); // UrlSegment
    // console.log("=============== JAVASCRIPT");
    // console.log(location);
    // console.log(window.location.href)
    // console.log(location.origin);
    
    this.base_url = location.origin;
    
  }

  getCars(vehicles: any) {
    for (let i = 0; i < vehicles.length; i++) {
      let car = {
        nombre: vehicles[i].name,
        imei: vehicles[i].IMEI,
        icon: vehicles[i].icon,
        nameoperation: vehicles[i].nameoperation,
      };
      this.cars.push(car);
    }
  }

  fStrMD(str: string) {
    let str2 = ('00' + str).substring(str.length);
    return str2;
  }

  async onShow(){
    // console.log("==== SHOW");
    // console.log("config",this.config);
    // console.log(this.displayFollowLink1);

    this.tengoLink = false;
    if (this.cars.length == 0) {
      if (!this.VehicleService.statusDataVehicle) {
        // this.spinner.show('loadingHistorialForm');
        this.VehicleService.dataCompleted.subscribe((vehicles) => {
          this.getCars(vehicles);
          // this.spinner.hide('loadingHistorialForm');
        });
      } else {
        let vehicles = this.VehicleService.getVehiclesData();
        this.getCars(vehicles);
      }
    }

    console.log(this.cars);
    //======================
    this.p_vehicles=[{
      icon:this.config.icon,
      imei:this.config.IMEI,
      nameoperation:this.config.nameoperation,
      nombre:this.config.name,
    }];

    this.vf = {
      fecha_desde : moment().startOf('day').toDate(),
      fecha_hasta : moment().startOf('day').toDate(),
      hora_desde : new Date('2018-03-12T00:00'),
      hora_hasta : new Date('2018-03-12T00:00'),

      array_vehicles : '',
      chk_historial_ruta : false,
      chk_historial_evento : false,
      nota : '',
      chk_mostrar_nota : false,
      chk_multiples_unidades : false,
      ruta_md5 : '',
      fecha_create : '',
    }

  }

  onClickCancel(){
    console.log("cancelar formulario");
  }

  confirm(){
    // this.loading=true;

    Swal.fire({
      title: '¿Está seguro?',
      text: 'Se generara el link de seguimiento',
      //icon: 'warning',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        actions: 'w-100',
        cancelButton: 'col-4',
        confirmButton: 'col-4',
      },
      preConfirm: async () => {
        await this.onSubmit();
      },
    }).then((data) => {
      if(data.isConfirmed) {
        // Swal.fire(
        //   'https://mapon.com/share?026bcba5bce2bf464c1fee14c25d619f',
        //   'Enviando este enlace a su cliente será capaz de localizar la ruta del vehículo actual en el periodo definido. El enlace expirará 24 después del fin del periodo.',
        //   'success'
        // );
        this.tengoLink = true;
        console.log('TENGOLINK ES VERDADERO');
      } else {
        console.log('(Vehicle Config) Hubo un error al guardar los cambios');
      }
      // this.loading=false;
    });
  }


  async onSubmit(){

    // this.vf = {
    //   // IMEI: this.config.IMEI,
    //   // name : this.valueNull(this.name.nativeElement.value),

    //   fecha_desde : '',//;this.valueNull(this.name.nativeElement.value),
    //   fecha_hasta : '',//this.valueNull(this.name.nativeElement.value),
    //   array_vehicles : '',
    //   chk_historial_ruta : '',
    //   chk_historial_evento : '',
    //   nota : '',
    //   chk_mostrar_nota : '',
    //   chk_multiples_unidades : '',
    //   ruta_md5 : '',
    //   fecha_create : '',
    // };
    console.log("============================    onSubmit    =====================================================");
    
    let MDstr = '' + moment(this.vf.fecha_desde).format('M');
    let DDstr = '' + moment(this.vf.fecha_desde).format('D');
    let HMDstr = '' + moment(this.vf.hora_desde).format('HH:mm:00');

    let MHstr = '' + moment(this.vf.fecha_hasta).format('M');
    let DHstr = '' + moment(this.vf.fecha_hasta).format('D');
    let HMHstr = '' + moment(this.vf.hora_hasta).format('HH:mm:00');

    var M1 = moment(this.vf.fecha_desde).format('YYYY')+'-' +this.fStrMD(MDstr) +'-' +this.fStrMD(DDstr) +'T'+HMDstr +'-05:00';
    var M2 = moment(this.vf.fecha_hasta).format('YYYY')+'-' +this.fStrMD(MHstr) +'-' +this.fStrMD(DHstr) +'T'+HMHstr +'-05:00';

    this.vf.fecha_desde_full = M1;
    this.vf.fecha_hasta_full = M2;

    let array_vehicles = this.config.IMEI;
    let array_iconos = this.config.icon;

    if (this.vf.chk_multiples_unidades) {
      let result = this.p_vehicles.map((a:any) => a.imei);
      array_vehicles = result.toString();

      let result1 = this.p_vehicles.map((a:any) => a.icon);
      array_iconos = result1.toString();

    }


    console.log("======= this.config ===============");
    console.log(this.config);
    console.log("========== VEHICLES ===============");
    console.log(this.p_vehicles);
    console.log("===== array_vehicles ==============");
    console.log(array_vehicles);
    this.vf.array_vehicles = array_vehicles;
    
    console.log(array_iconos);
    this.vf.array_iconos = array_iconos;

    console.log("==== this.vehicles_follow =========");
    console.log(this.vf);
    
    

    await this.configService.putVehicleFollow(this.vf).toPromise()
    .then( newConfig => {
      console.log("==========================");
      console.log(newConfig);
      console.log(newConfig.data[2].ruta_md5);
      
      this.strLink = this.base_url+'/seguimiento/'+newConfig.data[2].ruta_md5;

      this.tengoLink = true;
      console.log('TENGOLINK ES VERDADERO');

      if(newConfig.res){
        console.log("===== newConfig.res =====");
        
        // this.eventUpdate.emit(this.vehicle);
        // this.configService.onVehicleUpdate(newConfig.data);
        // //console.log('(Vehicle Config) Recibido data de guardado de cambios: ');
        // this.eventDisplay.emit(false);
      }
    }).catch(errorMsg => {
      console.log('(Vehicle Config) Error al guardar datos del Link para seguimiento: ', errorMsg)
    });

  }



}
